import uInt from './u-int.js';
import { AE_AMOUNT_FORMATS, formatAmount } from '../../../utils/amount-formatter.js';
export default {
  ...uInt,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  serializeAettos(value, params, options) {
    return value !== null && value !== void 0 ? value : '0';
  },
  serialize(value, params, {
    denomination = AE_AMOUNT_FORMATS.AETTOS,
    ...options
  }) {
    return uInt.serialize(this.serializeAettos(value != null ? formatAmount(value, {
      denomination
    }) : value, params, options));
  }
};
//# sourceMappingURL=coin-amount.js.map